import GuestGuard from '@/auth/main/route-guard/GuestGuard';
import Loadable from '@/common/presentation/components/utils/Loader/Loadable';
import { Outlet } from 'react-router-dom';
import { lazy } from 'react';
import { RouterErrorBoundary } from '@/common/presentation/components/ErrorBoundary/RouterErrorBoundary';

const Login = Loadable(lazy(() => import('@/auth/presentation/pages/Login/Login')));
const Register = Loadable(lazy(() => import('@/auth/presentation/pages/Register/Register')));
const ForgotPassword = Loadable(lazy(() => import('@/auth/presentation/pages/ForgotPassword/ForgotPassword')));
const ResetPassword = Loadable(lazy(() => import('@/auth/presentation/pages/ResetPassword/ResetPassword')));
const CheckMail = Loadable(lazy(() => import('@/auth/presentation/pages/CheckMail/CheckMail')));
const CodeVerification = Loadable(lazy(() => import('@/auth/presentation/pages/CodeVerification/CodeVerification')));

const AuthRoutes = {
  path: '/',
  errorElement: <RouterErrorBoundary />,
  element: (
    <GuestGuard>
      <Outlet />
    </GuestGuard>
  ),
  children: [
    {
      path: '/login',
      element: <Login />
    },
    {
      path: '/register',
      element: <Register />
    },
    {
      path: '/forgot-password',
      element: <ForgotPassword />
    },
    {
      path: '/reset-password/:token',
      element: <ResetPassword />
    },
    {
      path: '/reset-password',
      element: <ResetPassword />
    },
    {
      path: '/check-mail',
      element: <CheckMail />
    },
    {
      path: '/code-verification',
      element: <CodeVerification />
    }
  ]
};

export default AuthRoutes;
